import { Chip, Tooltip, type ChipProps, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';

type TStatusChipWithTooltipProps = {
  label: ReactNode;
  color?: ChipProps['color'];
  size?: ChipProps['size'];
  description?: ReactNode;
  chipSx?: SxProps<Theme>;
};

export const StatusChipWithTooltip = ({
  label,
  color = 'default',
  size = 'small',
  description,
  chipSx,
}: TStatusChipWithTooltipProps) => (
  <Tooltip title={description ?? ''}>
    <Chip size={size} label={label} color={color} sx={chipSx} />
  </Tooltip>
);
